import React from "react"
import ToastNotification from "./ToastNotification"

export interface ToastInfoProps {
  message: string
}

const ToastInfo: React.FC<ToastInfoProps> = ({ message }) => (
  <ToastNotification message={message} type="info" />
)

export default ToastInfo
